<div fxLayout="row" fxLayoutGap="5px">
    <img role="none" *ngIf="true" src="./assets/img/export_docs_icon.png" [width]="16" (click)="selectionChange(!isSelected)"  alt="export"/>

    <kendo-switch [ngModel]="isSelected" (valueChange)="selectionChange($event)" onLabel="'export'" size="small"
        offLabel=""></kendo-switch>
</div>